import { z } from 'zod';
import { SaleType } from '../../types';

export const DeskingSaleDetailsPartSchema = z.object({
  saleDetails: z.object({
    fees: z.number(),
    netRate: z.number(),
    salesTax: z.number(),
    invoiceTotal: z.number(),
    financeAmount: z.number(),
    equipmentSubtotal: z.number(),
    saleType: z.nativeEnum(SaleType),
    downPayment: z.object({ flat: z.number(), percent: z.number() }),
  }),
});
